import AdminLayout from "../../components/admin/layouts/AdminLayout";

const AdminIndexPage = () => {
  return <AdminLayout></AdminLayout>;
};
export default AdminIndexPage;
